// Service page content for Prospective Marriage visa (Subclass 300).
// Sourced from docs/research/australian-visa-pathways.md §3.
// COMPLIANCE: we gather and organise relationship and intention-to-marry
// evidence; a registered migration agent gives the migration advice and lodges.
// No guaranteed outcomes; empathetic, honest tone.

const prospectiveMarriage300 = {
  groupSlug: "family-partner",
  slug: "prospective-marriage-300",
  title: "Prospective Marriage visa (Subclass 300)",
  eyebrow: "Family & Partner",
  intro:
    "The Subclass 300 is for the fiance or fiancee of an Australian citizen, permanent resident, or eligible New Zealand citizen. It lets you come to Australia to marry your partner, after which you apply onshore for a partner visa. It is the bridge between engagement and building your life together in Australia.",

  chips: [
    { label: "Visa type", value: "Temporary, leads to partner visa" },
    { label: "Sponsor", value: "Citizen, PR, or eligible NZ citizen" },
    { label: "Validity", value: "Time-limited to marry" },
    { label: "Next step", value: "Onshore partner visa (820/801)" },
  ],

  whoFor: [
    "Engaged couples where one partner is an Australian citizen, permanent resident, or eligible New Zealand citizen.",
    "People who intend to marry in Australia within the visa period.",
    "Couples who have met in person and can evidence a genuine relationship.",
  ],

  essentials: [
    {
      title: "A genuine intention to marry",
      detail:
        "You must intend to marry your sponsoring partner within the validity of the visa.",
    },
    {
      title: "You have met in person",
      detail:
        "You generally must have met your partner face to face and be known to each other as adults.",
    },
    {
      title: "An eligible sponsor",
      detail:
        "Your partner must be an Australian citizen, permanent resident, or eligible New Zealand citizen who meets sponsorship requirements.",
    },
    {
      title: "Evidence of a genuine relationship",
      detail:
        "As with partner visas, genuine relationship evidence matters, alongside evidence of your wedding plans.",
    },
    {
      title: "Marry within the visa period",
      detail:
        "Once in Australia, you marry within the visa validity, then lodge an onshore partner visa.",
    },
    {
      title: "Health and character",
      detail:
        "You must meet the Department's health and character requirements.",
    },
  ],

  process: [
    {
      title: "Match with a registered agent",
      detail:
        "A registered migration agent confirms that the 300 is the right path for your situation and timing.",
    },
    {
      title: "Build the evidence",
      detail:
        "We help you gather and organise evidence of both your relationship and your genuine intention to marry.",
    },
    {
      title: "Lodge the application",
      detail:
        "We prepare and organise a thorough file, and a registered migration agent lodges it and deals with the Department.",
    },
    {
      title: "Travel and marry",
      detail:
        "Once granted, you enter Australia and marry within the visa period.",
    },
    {
      title: "Move to a partner visa",
      detail:
        "We then organise your onshore partner visa documents so a registered migration agent can progress you toward permanent residence.",
    },
  ],

  faqs: [
    {
      q: "Do we have to marry within a set time?",
      a: "Yes. The 300 is granted on the basis that you will marry within its validity period. After the marriage, you apply onshore for a partner visa. We help you keep the timing organised, and a registered migration agent advises on the deadlines so nothing lapses.",
    },
    {
      q: "Should we use the 300 or apply for a partner visa directly?",
      a: "It depends on whether you are married yet and where you each are. If you are already married, a partner visa may be more direct. If you plan to marry in Australia, the 300 can be the right bridge. A registered migration agent advises on the best fit for you.",
    },
    {
      q: "What happens after we marry?",
      a: "You lodge an onshore partner visa (820/801). Your time and evidence from the 300 carry forward, and we prepare and organise the partner application file so a registered migration agent can lodge it and continue your pathway to permanent residence.",
    },
    {
      q: "Does the 300 lead to permanent residence?",
      a: "Not on its own. It is a step toward the partner visa, which is the route to permanent residence. A registered migration agent maps the pathway, and we keep the documentation and each stage organised from the start.",
    },
  ],

  related: ["partner-visa", "child-visa", "parent-visa"],

  lastVerified: "13 July 2026",
};

export default prospectiveMarriage300;
